<template>
	
<core-card-foot-stat :value="value" :text="field.label" />

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		value: function() {

			var contextual = (this.item.context) ? this.item.context : this.item
            
            return this.$_.keys(contextual.users.played).length

        }

	}

}

</script>

<style scoped>

</style>
